import { Crown, GraduationCap, Flower2, Glasses, Heart, Ribbon, Bell, Gem, Sparkles, CircleDashed, Rainbow } from "lucide-react";

const HEAD = {
  krone: <Crown className="w-full h-full text-amber-400 drop-shadow" fill="#fcd34d" strokeWidth={1.5} />,
  doktorhut: <GraduationCap className="w-full h-full text-slate-800 drop-shadow" fill="#1e293b" strokeWidth={1.5} />,
  blumen: <span className="flex justify-center gap-[2%]">{[0, 1, 2].map((i) => <Flower2 key={i} className="w-1/3 h-auto text-pink-500" fill="#fbcfe8" />)}</span>,
  heiligenschein: <span className="block mx-auto w-[85%] aspect-[3/1] rounded-[50%] border-[3px] border-amber-300 shadow-[0_0_14px_#fde68a]" />,
};
const EYES = {
  brille: <Glasses className="w-full h-full text-slate-800" strokeWidth={2.2} />,
  sonnenbrille: <Glasses className="w-full h-full text-slate-900" fill="#0f172a" strokeWidth={2.2} />,
  herzbrille: <span className="flex justify-center gap-[18%]">{[0, 1].map((i) => <Heart key={i} className="w-[36%] h-auto text-rose-500" fill="#f43f5e" />)}</span>,
};
const NECK = {
  schleife: <Ribbon className="w-full h-full text-rose-500" fill="#fda4af" strokeWidth={1.6} />,
  glocke: <Bell className="w-full h-full text-amber-500" fill="#fcd34d" strokeWidth={1.6} />,
  kette: <Gem className="w-full h-full text-sky-500" fill="#bae6fd" strokeWidth={1.6} />,
};

const KNOWN = new Set(["hund", "katze", "hase", "drache", "itzling"]);

export function PetAvatar({ kind, name, equipped = {}, className = "w-40 h-40", imgClass = "", testId }) {
  const e = equipped || {};
  return (
    <div className={`relative ${className}`} data-testid={testId}>
      {e.effekt === "regenbogen" && <span className="absolute -inset-[6%] rounded-full pet-rainbow" aria-hidden data-testid="pet-acc-effekt" />}
      <img src={`/pets/${KNOWN.has(kind) ? kind : "itzling"}.webp`} alt={name} onError={(ev) => { if (!ev.currentTarget.src.endsWith("/pets/itzling.webp")) ev.currentTarget.src = "/pets/itzling.webp"; }} className={`relative w-full h-full rounded-full object-cover ${imgClass}`} />
      {e.kopf && <span className="absolute left-1/2 -translate-x-1/2 top-[-6%] w-[34%] pointer-events-none" data-testid="pet-acc-kopf">{HEAD[e.kopf]}</span>}
      {e.augen && <span className="absolute left-1/2 -translate-x-1/2 top-[33%] w-[42%] pointer-events-none" data-testid="pet-acc-augen">{EYES[e.augen]}</span>}
      {e.hals && <span className="absolute left-1/2 -translate-x-1/2 top-[58%] w-[18%] pointer-events-none" data-testid="pet-acc-hals">{NECK[e.hals]}</span>}
      {e.effekt === "glitzer" && <span className="sr-only" data-testid="pet-acc-effekt">Glitzer</span>}
      {e.effekt === "glitzer" && [["top-[4%] left-[6%]", "w-[16%]"], ["top-[18%] right-[2%]", "w-[12%]"], ["bottom-[10%] left-[2%]", "w-[11%]"]].map(([pos, w], i) => (
        <Sparkles key={i} className={`absolute ${pos} ${w} h-auto text-amber-300 animate-pulse pointer-events-none`} fill="#fde68a" style={{ animationDelay: `${i * 400}ms` }} />
      ))}
    </div>
  );
}

export const ITEM_ICON = { krone: Crown, doktorhut: GraduationCap, blumen: Flower2, heiligenschein: CircleDashed, brille: Glasses, sonnenbrille: Glasses, herzbrille: Heart, schleife: Ribbon, glocke: Bell, kette: Gem, glitzer: Sparkles, regenbogen: Rainbow };
